import styled from "styled-components";

export const Logo = styled.img.attrs(() => ({ src: `/assets/gamepleasethanks.png` }))`
  image-rendering: pixelated;
  image-rendering: -moz-crisp-edges;
`;
